import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {listFromMap, valueFromList} from "../../../helper/list.helper";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-manager-log',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './manager-log.component.html',
  styleUrl: './manager-log.component.scss'
})
export class ManagerLogComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/manager-log-edit/';
  override addLink = '/dashboard/manager-log-create';

  managerList: Record<string, string> = {};
  managerListMap: {value: string, label: string}[] = [];

  constructor(crudService: CrudService,
              protected cdr: ChangeDetectorRef,
              router: Router) {

    super(crudService, router);


    this.crudService.setProvider('manager-log');
    this.crudService.orderBy = 'createdAt';

  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'Created At',
        field: 'createdAt',
        sortable: true,
        filterType: EFilterType.DATE,
        value: (item) => (new Date(item.createdAt || Date.now())).toLocaleString(),
        crudFilterType: ECrudFilterType.DATE,
      },
      {
        header: 'Manager',
        field: 'managerId',
        sortable: true,
        filterType: EFilterType.SELECT,
        value: valueFromList(this, 'managerList', 'managerId'),
        options: () => this.managerListMap,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Action',
        field: 'action',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'Details',
        field: 'details',
        sortable: false,
        filterType: EFilterType.TEXT,
      },
    ],
    actions: [
      'edit',
      'delete',
    ]
  };

  ngOnInit() {
    this.update();
    this.crudService.getList('manager', 'id', 'nickname').then(data => {
      this.managerList = data;
      this.managerListMap = listFromMap(data);

      this.cdr.detectChanges();
    });
  }
}
